require('styles/Content.css');
import React from 'react';
import Rsvp from './Rsvp';

let benicePhoto = require('../images/benice-dron.jpg');
let beniceMap = require('../images/map.png');

class Content extends React.Component {
  render() {
    return (
      <div className="content">

        <div className="row">
          <div className="col l12 s12">
            <div className="card welcome">
              <div className="card-content">
                <p className="center-align">
                  Rádi bychom Vás pozvali na naši svatbu, která se bude konat <b>5. května 2018 na statku v Benicích</b>.<br/>Na
                  této stránce najdete všechny detaily týkající se svatebního dne. Budeme se na Vás těšit.<br/><br/>
                  <i>Evča a Kuba</i>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col s12 l8">
            {/*<div className="card">*/}
            {/*<div className="card-content">*/}
            {/*<span className="card-title">Novinky</span>*/}
            {/*<p>Více info již brzy...</p>*/}
            {/*</div>*/}
            {/*</div>*/}

            <div className="card">
              <div className="card-content">
                <span className="card-title">Místo konání svatby</span>
                <div className="row">
                  <div className="col m5">
                    <p>
                      <br/>
                      <a href="https://goo.gl/maps/XDeDmmkUFL22" className="place-title" target="_blank">Barokní statek
                        Benice</a><br/>
                      Benice 1<br/>
                      257 44 Chrášťany<br/>
                      <a href="https://www.favory.cz">www.favory.cz</a>
                    </p>
                    <br/>
                    <b>Cesta z Prahy</b>
                    <p>cca. 50km (45 min) - viz. mapa níže</p>
                    <br/>
                  </div>
                  <div className="col m7">
                    <img src={benicePhoto} alt="Foto Benice"/>
                  </div>
                </div>

                <br/>
                <img src={beniceMap} alt="Mapa"/>
              </div>
            </div>

            <div className="card map">
              <div className="card-content">
                <iframe frameBorder="0"
                        src="https://www.google.com/maps/embed/v1/place?q=place_id:ChIJ-0uLP4OBC0cRlbImaS1I6Qk&key=AIzaSyBWSJXLHMOLjj1s3omYoe2tUx167w_j8Mc&center=49.951569,14.248960&zoom=9"
                        allowFullScreen/>
              </div>
            </div>

            <div className="card">
              <div className="card-content">
                <span className="card-title">Ubytování</span>
                <p>V Benicích lze samozřejmě využít možnosti ubytování a to za 500Kč za osobu. Jelikož je počet lůžek
                  omezený, jsou k dispozici také matrace za 200Kč za osobu, které se mohou rozmístit do jednotlivých
                  pokojů či jsou zde větší pokoje pouze pro matrace – včetně sociálního zařízení. S touto variantou ať
                  prosím předběžně počítají bezdětní hosté do třiceti let (bude třeba si přivést vlastní spacák).</p>
              </div>
            </div>

            <div className="card">
              <div className="card-content">
                <span className="card-title">Další informace</span>
                <b>Svatební dary</b>
                <p>Největším darem je pro nás Vaše účast na svatbě. Pokud byste nás však i přesto nějakým darem chtěli
                  poctít, oceníme jakýkoliv příspěvek na svatební cestu.
                </p>
                <br/>
                <b>Hudba</b>
                <p>Jelikož si svatební Playlist sestavujeme sami, budeme moc rádi, pokud nám každý pošlete jednu až dvě
                  písně, které byste ocenili a myslíte, že by neměly chybět.
                </p>
                <br/>
                <b>Dress code</b>
                <p>Hodně lidí se nás ptalo, do jaké barvy máme svatbu laděnou a jaký je dresscode. Barvy dekorace ladíme
                  do bíla se zelenou ve formě různých rostlin, nemyslíme však, že byste museli nutně všichni ladit ke
                  svatebnímu stolu. Z toho důvodu žádný dresscode není, stačí, když budete všichni pěkní a spokojení.
                </p>
                <br/>
                <b>Děti</b>
                <p>Všechny děti jsou samozřejmě vítány jelikož jsou vaší součástí. Budeme však rádi, pokud se během
                  obřadu o své potomky postaráte a zajistíme tak klidný průběh.
                </p>

              </div>
            </div>
            <Rsvp/>
            <div className="row">
              <div className="card">
                <div className="video-wrapper">
                  <iframe src="https://www.youtube.com/embed/mx8ZU3aK7rQ?autoplay=1&showinfo=0&controls=0&loop=1&modestbranding=1&rel=0&playlist=mx8ZU3aK7rQ"
                          frameBorder="0" allowFullScreen/>
                </div>
              </div>
            </div>
          </div>
          <div className="col s12 l4">
            <div className="card schedule">
              <div className="card-content">
                <span className="card-title">Harmonogram dne</span>
                <div>
                  <blockquote>
                    <h4>12:00 - 13:00</h4>
                    <p>Příjezd a ubytování hostů</p>
                  </blockquote>

                  <blockquote>
                    <h4>14:00</h4>
                    <p>Svatební obřad</p>
                  </blockquote>

                  <blockquote>
                    <h4>14:30</h4>
                    <p>Fotografování svatebčanů</p>
                  </blockquote>

                  <blockquote>
                    <h4>15:00</h4>
                    <p>Svatební přípitek a následný raut</p>
                  </blockquote>

                  <blockquote>
                    <h4>17:30</h4>
                    <p>Krájení svatebního dortu</p>
                  </blockquote>

                  <blockquote>
                    <h4>18:30</h4>
                    <p>Večerní grilování</p>
                  </blockquote>

                  <blockquote>
                    <h4>19:30</h4>
                    <p>První tanec novomanželů</p>
                  </blockquote>

                  <blockquote>
                    <h4>20:30</h4>
                    <p>Házení kyticí</p>
                  </blockquote>

                  <blockquote>
                    <h4>21:00</h4>
                    <p>Večerní zábava</p>
                  </blockquote>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

Content.defaultProps = {};

export default Content;



// WEBPACK FOOTER //
// ./src/components/Content.js